export default "__VITE_ASSET__B16orq3A__"